import * as React from 'react'
import './index.scss'
import { ModuleCardProps } from './types'
import { Icon } from '@petz/ds-icon'
import { ModuleContext } from '../../hooks/ModuleContext'
import { SegmentContext } from '../../hooks/SegmentContext'

export const ModuleCard: React.FC<ModuleCardProps> = ({ id, icon, title, isAvailable, isAvailableText, notAvailableText }) => {
  const safeId = id ?? 'all'
  const safeIcon = icon ?? 'question-circle'
  const isChat = !!isAvailableText && typeof isAvailable === 'boolean'
  const safeAvailableText = isAvailableText ?? 'Disponível'
  const safeNotAvailableText = notAvailableText ?? safeAvailableText
  const chatText = isAvailable ? safeAvailableText : safeNotAvailableText
  const safeTitle = title ?? 'Título do card'

  const { setModule } = React.useContext(ModuleContext)
  const { segmentTrack } = React.useContext(SegmentContext)

  function handleCardClick() {
    setModule(safeId)
    segmentTrack('Help Option Clicked', { alt_text: 'ajuda-alt', widget: true, help_section: safeTitle, button_name: safeId })
  }

  return (
    <button className={`module-card-container ${safeId}`} onClick={handleCardClick}>
      <Icon size="md" name={safeIcon} variant="line" className="module-card-icon" />
      <p className="module-card-text">{safeTitle}</p>
      {isChat ? (
        <div className={`chat-availability ${isAvailable ? 'active' : 'inactive'}`}>
          <p className={`chat-availability-text`}>{chatText}</p>
          <div className="chat-availability-circle" />
        </div>
      ) : null}
    </button>
  )
}
